import type { UserDisplayData } from 'ComponentLibrary/src/common/users'
import type { UUID } from 'ComponentLibrary/src/common/uuid'

type UserPresentationIdentity = {
    /** Stable identity used to deduplicate presentation entries and as their React list key. Include the identity domain in the value. */
    key: string
}

export type AccountDisplayData = UserDisplayData & ({ uuid: UUID } | { id: NonNullable<UserDisplayData['id']> })
export type ExternalParticipantDisplayData = UserDisplayData & { uuid: UUID }

export type UserPresentation = UserPresentationIdentity &
    (
        | { kind: 'account'; displayData: AccountDisplayData }
        | { kind: 'nonUser'; displayData: UserDisplayData }
        | { kind: 'externalParticipant'; displayData: UserDisplayData }
        | { kind: 'unavailable' }
    )

export function createAccountPresentation(account: AccountDisplayData): Extract<UserPresentation, { kind: 'account' }> {
    return {
        kind: 'account',
        key: `account:${account.uuid ?? account.id}`,
        displayData: account,
    }
}

export function createExternalParticipantPresentation(
    participant: ExternalParticipantDisplayData
): Extract<UserPresentation, { kind: 'externalParticipant' }> {
    return {
        kind: 'externalParticipant',
        key: `external-participant:${participant.uuid}`,
        displayData: participant,
    }
}
